import { useState, useEffect, useContext } from 'react'
import EnvContext from '../context/EnvContext'

import { gql, useQuery } from '@apollo/client';


const USER_QUERY_SELECTIVE = gql`
query ($envName: String!, $_in: [bigint!]) {
  ttuser(where: {environment: {name: {_eq: $envName}}, id: {_in: $_in}}) {
    id
    userEmail
    userFirstName
    userLastName
    alias
  }
}
`

export const useTTUSUserSelective = (ids, wait_for_connectionList = true) => {

    const envSelected = useContext(EnvContext)
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(USER_QUERY_SELECTIVE, {
        variables: ids.length === 0 && wait_for_connectionList === false? {
            "envName": envSelected
        } : {
            "envName": envSelected,
            "_in": ids
        }
    })

    useEffect(() => {
        if (!loading && data) {
            setLookupData(data.ttuser.reduce((acc, d) => {
                if (d)
                    acc[d.id] = {
                        'id': d.id,
                        'email': d.userEmail,
                        'first': d.userFirstName,
                        'last': d.userLastName,
                        'alias': d.alias
                    }
                return acc
            }, {}))
        }
    }, [data, loading, envSelected])

    return lookupData
}
